import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs"
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import InventoryTableSection from "./InventoryTableSection";



const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Network Inventory",
        redirectTo: "/inventory",
    }
]


function InventoryPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Network Inventory: Nmap')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <div className="network-scan-page-v2">
            <InfoBoxes />
            <InventoryTableSection />
        </div>
    )

}

export default withMainLayout(connect()(InventoryPage));
